var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#767571",
  d: "M17.176 4h2.76l-6.03 6.892L21 20.27h-5.554l-4.35-5.688-4.979 5.688H3.355l6.45-7.371L3 4h5.695l3.933 5.199zm-.969 14.618h1.53L7.864 5.565h-1.64z"
})));
export default SvgTwitter;